import { render, staticRenderFns } from "./SendVerifyCode.vue?vue&type=template&id=fccdf88a&scoped=true"
import script from "./SendVerifyCode.vue?vue&type=script&lang=js"
export * from "./SendVerifyCode.vue?vue&type=script&lang=js"
import style0 from "./SendVerifyCode.vue?vue&type=style&index=0&id=fccdf88a&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccdf88a",
  null
  
)

export default component.exports